import "./FlightSearch.css";
import SelectSearch from 'react-select-search';

import { Card, Dropdown, ButtonGroup } from "react-bootstrap";
import { DropdownButton } from "react-bootstrap";
import _defaultimg from "../../libs/images/flightimg.jpg";
import ReturnFlight from "./ReturnFlight";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBottomSticky, setCalenderFare, setSearchDataUser, setSearchFlights } from "../../redux/global/global.action";
import { get_calendar_fare, search_flights_data, showAlertMessage } from "../server/api";
import moment from "moment";
import { matchSorter } from 'match-sorter'
import DatePicker from "react-datepicker";
import Loader from "../loader/Loader";
import { useHistory } from "react-router-dom";

var Scroll = require('react-scroll');
var scroll = Scroll.animateScroll;

const FlightSearch = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [multicityairports, setMulticityAirports] = useState([])
  const [multicityairports2, setMulticityAirports2] = useState([])
  const airport_list = useSelector(state => state.global.airport_list)
  const flight_token = useSelector(state => state.global.flight_token)
  const search_data = useSelector(state => state.global.search_data)
  const [rowsData,setRowsData] = useState([
    {
      OriginName:'',
      DestinationName:'',
      Origin:'',
      Destination:'',
      FlightCabinClass:1,
      PreferredDepartureTime:new Date(),
      PreferredArrivalTime:new Date()
  }
  ])
  const [segments, setSegments] = useState([
    {
      OriginName: '',
      DestinationName: '',
      Origin: '',
      Destination: '',
      FlightCabinClass: 1,
      PreferredDepartureTime: new Date(),
      PreferredArrivalTime: new Date()
    }
  ])
  const [airports, setAirports] = useState([]);

  const [loadcircle, setLoadCircle] = useState(0)
  const [airports2, setAirports2] = useState([]);
  const [passengerdropdown, setPassengerDropdown] = useState(0);


  const setSearchData = (data) => {
    dispatch(setSearchDataUser({ ...data }))
  }

  const search_flights = () => {
    dispatch(setBottomSticky(0))
    const { departure_date, flight_from, flight_to, adultcount, journeyType, arrival_date } = search_data;

    if (departure_date == '' && journeyType != 3) {
      showAlertMessage('oops', 'Please select departure date!', false, true)
    } else if (flight_from == '' && journeyType != 3) {
      showAlertMessage('oops', 'Please select source', false, true)

    } else if (flight_to == '' && journeyType != 3) {
      showAlertMessage('oops', 'Please select destination', false, true)

    }
    else if (flight_from === flight_to && journeyType != 3) {
      showAlertMessage('oops', 'Origin & Destination can\'t be same!', false, true)

    } else if (adultcount == 0) {
      showAlertMessage('oops', 'Please select adults!', false, true)
    } else if (journeyType == 2 && arrival_date == '') {
      showAlertMessage('oops', 'Please select arrival date!', false, true)

    }
    else {
      const new_arr = [];
      if (rowsData.length) {
        for (let i = 0; i < rowsData.length; i++) {
          const element = rowsData[i];
          new_arr.push({
            ...element,
            PreferredArrivalTime: moment(element.PreferredArrivalTime).format('YYYY-MM-DD') + 'T00: 00: 00',
            PreferredDepartureTime: moment(element.PreferredDepartureTime).format('YYYY-MM-DD') + 'T00: 00: 00',
          })

        }
      }


      const arr = {
        ...search_data,
        Segments: new_arr,
        departure_date: moment(search_data.departure_date).format('YYYY-MM-DD'),
        arrival_date: moment(search_data.arrival_date).format('YYYY-MM-DD')
      }

      setLoadCircle(1)
      search_flights_data(arr).then((res) => {
        setLoadCircle(0);
        dispatch(setSearchFlights(res))
        if (res.status) {
          // scroll.scrollTo(700);
          let obj = {
            adultcount: search_data.adultcount,
            childcount: search_data.childcount,
            infantcount: search_data.infantcount
          }
          localStorage.setItem('request_passenger', JSON.stringify(obj))
          history.push('/flight-list')
        } else {
          showAlertMessage('oops', res.message, false, true)
        }
      })

      if (journeyType != 3) {
        const clndr_arr = {
          ...arr,
          arrival_date: moment(search_data.departure_date).format('YYYY-MM-DD')
        }
        get_calendar_fare(clndr_arr).then((res) => {
          // debugger;
          dispatch(setCalenderFare(res))
        })
        // .catch((err) => {
        //   console.log('=============error=======================');
        //   console.log(err);
        //   console.log('====================================');
        // })
      }

    }

  }

  const set_segment_status = (segment_no,obj) => {
    var seg = rowsData
        seg[segment_no] = {
            ...seg[segment_no],
            ...obj
        }
        setRowsData(seg)
        multicityairports[segment_no] = []
            setMulticityAirports(multicityairports)

            multicityairports2[segment_no] = [];
            setMulticityAirports2(multicityairports2)
        setAirports([])
    setAirports2([])
    
}

  const addTableRows = ()=>{
  
    const rowsInput={
      OriginName:'',
      DestinationName:'',
      Origin:'',
      Destination:'',
      FlightCabinClass:1,
      PreferredDepartureTime:new Date(),
      PreferredArrivalTime:new Date() 
    } 

    const lengthc = rowsData.length;
        if(lengthc>0){
            const get_last_row = rowsData[lengthc-1];
            const { OriginName,
            DestinationName,
            Origin,
            Destination,
            FlightCabinClass,
            PreferredDepartureTime,
            PreferredArrivalTime} = get_last_row
            if(Origin==''){
                showAlertMessage('oops','Please select origin!',false,true)
            }else if(Destination == ''){
                showAlertMessage('oops','Please select destination',false,true)
            }
            else if(Origin === Destination){
                showAlertMessage('oops','Origin & Destination can\'t be same!',false,true)
            }else if(PreferredDepartureTime == ''){
                showAlertMessage('oops','Please select date!',false,true)

            }else{
              setRowsData([...rowsData, rowsInput])

            }
          }else{

    setRowsData([...rowsData, rowsInput])

          }
  
  }
  const deleteTableRows = (index)=>{
      const rows = [...rowsData];
      rows.splice(index, 1);
      setRowsData(rows);
  }


  const handleChange2 = (e,index) => {
    var mlairport = multicityairports;
    var mlairport2 = multicityairports2;
    dispatch(setBottomSticky(0))

   

    if(e.target.name === 'flight_from_name'){
        if(e.target.value.trim() == ''){
            setAirports([])
            mlairport[index] = []
            setMulticityAirports(mlairport)
        }else{
            const arr = matchSorter(airport_list,e.target.value.trim(),{keys: ['name', 'code','city_name']})
            mlairport[index] = [...arr]
            setMulticityAirports(mlairport)
            setAirports(arr)
        }

        var seg = rowsData
        seg[index] = {
            ...seg[index],
            OriginName:e.target.value.trim()
        }
        setRowsData(seg)
    }
    if(e.target.name === 'flight_to_name'){
        if(e.target.value.trim() == ''){
            setAirports2([])
            mlairport2[index] = []
            setMulticityAirports2(mlairport2)
        }else{
            const arr2 = matchSorter(airport_list,e.target.value.trim(),{keys: ['name', 'code','city_name']})
            mlairport2[index] = [...arr2]
            setMulticityAirports2(mlairport2)
            setAirports2(arr2)
        }

        var seg2 = rowsData
        seg2[index] = {
            ...seg2[index],
            DestinationName:e.target.value.trim()
        }
        setRowsData(seg2)

    }
    // const { name, value } = e.target;
    // const rowsInput = [...rowsData];
    // rowsInput[index][name] = value;
    // setRowsData(rowsInput);
    // setSearchData({
    // ...search_data,
    // [e.target.name]: e.target.value.trim()
    // });

    // console.log(rowsData);
};
  // const handleChange2 = (index, evnt)=>{
  //   const { name, value } = evnt.target;
  //   const rowsInput = [...rowsData];
  //   rowsInput[index][name] = value;
  //   setRowsData(rowsInput);
  // }

  const set_journey_type = (type = 1) => {
    console.log(type);
    setSearchData({
      ...search_data,
      journeyType: type
    })
  }
  useEffect(() => {
    setSearchData({
      ...search_data,
      TokenId: flight_token.TokenId
    })
  }, [])


  const handleSelectAirport = async (name, code, type = 'from') => {
    if (type === 'from') {
      setSearchData({
        ...search_data,
        flight_from_name: name,
        flight_from: code,
      })
    } else {
      setSearchData({
        ...search_data,
        flight_to_name: name,
        flight_to: code,
      })
    }
    setAirports([])
    setAirports2([])
  }
  const handleChange = (e) => {
    dispatch(setBottomSticky(0))
    if (e.target.name === 'flight_from_name') {
      if (e.target.value.trim() == '') {
        setAirports([])
      } else {
        const arr = matchSorter(airport_list, e.target.value.trim(), { keys: ['name', 'code', 'city_name'] })
        setAirports(arr)
      }
    }
    if (e.target.name === 'flight_to_name') {
      if (e.target.value.trim() == '') {
        setAirports2([])
      } else {
        const arr = matchSorter(airport_list, e.target.value.trim(), { keys: ['name', 'code', 'city_name'] })
        setAirports2(arr)
      }
    }
    setSearchData({
      ...search_data,
      [e.target.name]: e.target.value.trim()
    });
  };
  return (
    <Card>
      <Card.Header>
        {
          loadcircle ? <Loader /> : ''
        }
        <div className="row">
          <div className="col-lg-2 col-sm-12 col-5">1. Flight Search </div>
          <div className="col-lg-2 col-sm-12 col-5">2. Flight Result</div>
          <div className="col-lg-2 col-sm-12 col-6">3. Passenger Details</div>
          <div className="col-lg-2 col-sm-12 col-6">4. Review Booking</div>
          <div className="col-lg-2 col-sm-12 col-7">
            5. Booking Confirmation
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <div className="container">
          <div className="row">
            <div className="card">
              <div className="card-body">
                <button className={search_data.journeyType == 1 ? "col-lg-2 col-sm-3 col-12 oneway btn btn-outline-warning active" : "col-lg-2 col-sm-3 col-12 oneway btn btn-outline-warning"} onClick={() => set_journey_type(1)}>
                  OneWay
                </button>
                <button className={search_data.journeyType == 2 ? "col-lg-2 col-sm-3 col-12 oneway btn btn-outline-warning active" : "col-lg-2 col-sm-3 col-12 oneway btn btn-outline-warning"} onClick={() => set_journey_type(2)}>
                  Return
                </button>
                <button className={search_data.journeyType == 3 ? "col-lg-2 col-sm-3 col-12 oneway btn btn-outline-warning active" : "col-lg-2 col-sm-3 col-12 oneway btn btn-outline-warning"} onClick={() => set_journey_type(3)}>
                  Multi-Stop
                </button>
                {/* <button className="col-lg-2 col-sm-3 col-12 oneway btn btn-outline-warning">
                  Calandar Fare
                </button>
                <button className="col-lg-2 col-sm-3 col-12 oneway btn btn-outline-warning">
                  Advance Search
                </button> */}

                {
                  search_data.journeyType == 3 ?
                    <div className="col-lg-8">
                      {
                        rowsData.length ? 
                        rowsData.map((res,index)=>(
                          <>
                          <div className="row">
                            <div className="col-lg-6 col-sm-6 col-6">
                              <form>
                                <div className="mb-3">
                                  <label className="form-label">From</label>
                                  <input
                                     onChange={(e)=>handleChange2(e,index)}  autoComplete="off" type="text" value={res.OriginName} name="flight_from_name" 
                                    className="form-control"
                                    placeholder="Enter Origin"
                                  />
                                  {
                                    multicityairports[index] ? 
                                      <ul class={multicityairports[index].length ? "dropdown-menu inner show" : "dropdown-menu inner"} role="presentation" style={{ marginTop: 0, marginBottom: 0 }}>
                                        {
                                          multicityairports[index] ?
                                            multicityairports[index].map((data) => {
                                              return (
                                                <li key={data.id} onClick={()=>set_segment_status(index,{OriginName:data.name+' '+data.city_name,Origin:data.code})}  style={{ cursor: 'pointer' }} class="dropdown-item"><span class="text">{data.name ? data.name + ', ' : ''} {data.city_name}</span></li>
                                              );
                                            })
                                            : ''
                                        }
                                      </ul>
                                    :''
                                  }
    
                                 
    
                                </div>
                              </form>
                              <div className="flipArrow">
                                <a href="#" className="rotate360">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-arrow-left-right"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
                            <div className="col-lg-6 col-sm-6 col-6">
                              <form>
                                <div class="mb-3">
                                  <label className="form-label">To</label>
                                  <input
                                    type="place"
                                    onChange={(e)=>handleChange2(e,index)}  autoComplete="off" name="flight_to_name" value={res.DestinationName}
                                    className="form-control"
                                    placeholder="Enter Destination"
                                  />
                                  {
                                    multicityairports2[index] ? 
                                      <ul class={multicityairports2[index].length ? "dropdown-menu inner show" : "dropdown-menu inner"} role="presentation" style={{ marginTop: 0, marginBottom: 0 }}>
                                        {
                                          multicityairports2[index] ?
                                            multicityairports2[index].map((data) => {
                                              return (
                                                <li key={data.id} onClick={()=>set_segment_status(index,{DestinationName:data.name+' '+data.city_name,Destination:data.code})}  style={{ cursor: 'pointer' }} class="dropdown-item"><span class="text">{data.name ? data.name + ', ' : ''} {data.city_name}</span></li>
                                              );
                                            })
                                            : ''
                                        }
                                      </ul>
                                    :''
                                  }
                                </div>
                              </form>
                            </div>
                          </div>
                           <div className="row mb-2">
                              <div className="col-lg-12">Depart</div>
                              <div className="col-lg-3 col-sm-3 col-6">
                              <DatePicker className="date-range form-control"
                                  minDate={moment().toDate()}
                                  placeholderText="Select Departure Date"
                                  selected={res.PreferredDepartureTime} onChange={(date) => set_segment_status(
                                      index,
                                      {
                                          PreferredArrivalTime:date,
                                          PreferredDepartureTime:date
                                      }
                                  )}
                                  />
                              </div>
                              
                           </div>
                           </>
                        ))
                        :""
                      }
                     
                      <div className="row">
                        <div className="col-lg-12">
                            <div class="form-group">
                                  <button class="theme-btn add-flight-btn margin-top-40px w-100" onClick={addTableRows}  type="button"><i class="la la-plus mr-1"></i>Add flight</button>
                              </div>
                          </div>
                        


                        {
                          search_data.journeyType == 2 ?
                            <>
                              <div className="col-lg-12 marginTop">Arrival</div>
                              <div className="col-lg-3 col-sm-3 col-6">
                                <DatePicker className="date-range form-control"
                                  minDate={moment(search_data.departure_date).toDate()}
                                  placeholderText="Select Arrival Date"
                                  selected={search_data.arrival_date} onChange={(date) => setSearchData(
                                    {
                                      ...search_data,
                                      arrival_date: date
                                    }
                                  )}
                                />
                              </div>
                            </>

                            : ''
                        }



                        <div className="col-lg-9 col-sm-9 col-6">
                          <>
                            {
                              ["Any Time"].map((variant) => (
                                <DropdownButton
                                  className="date"
                                  as={ButtonGroup}
                                  key={variant}
                                  id={`dropdown-variants-${variant}`}
                                  variant={variant.toLowerCase()}
                                  title={variant}
                                >
                                  <Dropdown.Item href="#">Any time</Dropdown.Item>
                                  <Dropdown.Item href="#">Morning</Dropdown.Item>
                                  <Dropdown.Item href="#">Afternoon</Dropdown.Item>
                                  <Dropdown.Item href="#">Evening</Dropdown.Item>
                                  <Dropdown.Item href="#">Night</Dropdown.Item>
                                </DropdownButton>
                              ))}
                          </>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 marginTop display-fare">
                          <div className="col-lg-3 col-sm-3 col-4 regular-student">
                            Select a fare type :
                          </div>
                          <div className="col-lg-3 col-sm-3 col-4">
                            <div class="form-check regular-student">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                class="form-check-label"
                                for="flexCheckDefault"
                              >
                                Regular Fare
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-3 col-4 studentMargin">
                            <div class="form-check regular-student">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                class="form-check-label"
                                for="flexCheckDefault"
                              >
                                Student Fare
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-3 col-sm-6 col-6 marginTop">
                          Adult (12+ Yrs)
                          <>
                            <div>

                              <select className="adult-border" onChange={handleChange} name="adultcount" value={search_data.adultcount}>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                              </select>
                            </div>
                          </>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-6 marginTop">
                          Children (2-11 Yrs)
                          <>
                            <div>
                              <select className="adult-border" onChange={handleChange} name="childcount" value={search_data.childcount}>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                              </select>
                            </div>
                          </>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-6 marginTop">
                          Infant (Under 2 Yrs)
                          <>
                            <div>
                              <select className="adult-border" onChange={handleChange} name="infantcount" value={search_data.infantcount}>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                              </select>
                            </div>
                          </>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-6 marginTop">
                          Class
                          <>
                            <div>
                              <select className="adult-border">
                                <option value="1" selected>All</option>
                                <option value="2" >Economy</option>
                                <option value="3" >Premium Economy</option>
                                <option value="4">Business</option>
                                <option value="5">Premium Business</option>
                                <option value="6">First class</option>
                              </select>

                            </div>
                          </>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-12 marginTop">
                          <button type="button"
                            onClick={search_flights}
                            className="btn btn-primary ">
                            Flight Search
                          </button>
                        </div>
                      </div>
                    </div>

                    :

                    <div className="col-lg-8">
                      <div className="row">
                        <div className="col-lg-6 col-sm-6 col-6">
                          <form>
                            <div className="mb-3">
                              <label className="form-label">From</label>
                              <input
                                onChange={handleChange} autoComplete="off" type="text" value={search_data.flight_from_name} name="flight_from_name"
                                className="form-control"
                                placeholder="Enter Origin"
                              />

                              <ul class={airports.length ? "dropdown-menu inner show" : "dropdown-menu inner"} role="presentation" style={{ marginTop: 0, marginBottom: 0 }}>
                                {
                                  airports ?
                                    airports.map((data) => {
                                      return (
                                        <li key={data.id} onClick={() => handleSelectAirport(data.name + ' ' + data.city_name.trim(), data.code, 'from')} style={{ cursor: 'pointer' }} class="dropdown-item"><span class="text">{data.name ? data.name + ', ' : ''} {data.city_name}</span></li>
                                      );
                                    })
                                    : ''
                                }
                              </ul>

                            </div>
                          </form>
                          <div className="flipArrow">
                            <a href="#" className="rotate360">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-left-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-6">
                          <form>
                            <div class="mb-3">
                              <label className="form-label">To</label>
                              <input
                                type="place"
                                onChange={handleChange} autoComplete="off" name="flight_to_name" value={search_data.flight_to_name}
                                className="form-control"
                                placeholder="Enter Destination"
                              />
                              <ul class={airports2.length ? "dropdown-menu inner show" : "dropdown-menu inner"} role="presentation" style={{ marginTop: 0, marginBottom: 0 }}>
                                {
                                  airports2 ?
                                    airports2.map((data) => {
                                      return (
                                        <li key={data.id} onClick={() => handleSelectAirport(data.name + ' ' + data.city_name.trim(), data.code, 'to')} style={{ cursor: 'pointer' }} class="dropdown-item"><span class="text">{data.name ? data.name + ', ' : ''} {data.city_name}</span></li>
                                      );
                                    })
                                    : ''
                                }
                              </ul>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 marginTop">Depart</div>
                        <div className="col-lg-3 col-sm-3 col-6">
                          <DatePicker className="date-range form-control"
                            minDate={moment().toDate()}
                            placeholderText="Select Departure Date"
                            selected={search_data.departure_date} onChange={(date) => setSearchData(
                              {
                                ...search_data,
                                departure_date: date
                              }
                            )}
                          />
                        </div>


                        {
                          search_data.journeyType == 2 ?
                            <>
                              <div className="col-lg-12 marginTop">Arrival</div>
                              <div className="col-lg-3 col-sm-3 col-6">
                                <DatePicker className="date-range form-control"
                                  minDate={moment(search_data.departure_date).toDate()}
                                  placeholderText="Select Arrival Date"
                                  selected={search_data.arrival_date} onChange={(date) => setSearchData(
                                    {
                                      ...search_data,
                                      arrival_date: date
                                    }
                                  )}
                                />
                              </div>
                            </>

                            : ''
                        }



                        <div className="col-lg-9 col-sm-9 col-6">
                          <>
                            {
                              ["Any Time"].map((variant) => (
                                <DropdownButton
                                  className="date"
                                  as={ButtonGroup}
                                  key={variant}
                                  id={`dropdown-variants-${variant}`}
                                  variant={variant.toLowerCase()}
                                  title={variant}
                                >
                                  <Dropdown.Item href="#">Any time</Dropdown.Item>
                                  <Dropdown.Item href="#">Morning</Dropdown.Item>
                                  <Dropdown.Item href="#">Afternoon</Dropdown.Item>
                                  <Dropdown.Item href="#">Evening</Dropdown.Item>
                                  <Dropdown.Item href="#">Night</Dropdown.Item>
                                </DropdownButton>
                              ))}
                          </>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 marginTop display-fare">
                          <div className="col-lg-3 col-sm-3 col-4 regular-student">
                            Select a fare type :
                          </div>
                          <div className="col-lg-3 col-sm-3 col-4">
                            <div class="form-check regular-student">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                class="form-check-label"
                                for="flexCheckDefault"
                              >
                                Regular Fare
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-3 col-4 studentMargin">
                            <div class="form-check regular-student">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                class="form-check-label"
                                for="flexCheckDefault"
                              >
                                Student Fare
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-3 col-sm-6 col-6 marginTop">
                          Adult (12+ Yrs)
                          <>
                            <div>

                              <select className="adult-border" onChange={handleChange} name="adultcount" value={search_data.adultcount}>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                              </select>
                            </div>
                          </>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-6 marginTop">
                          Children (2-11 Yrs)
                          <>
                            <div>
                              <select className="adult-border" onChange={handleChange} name="childcount" value={search_data.childcount}>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                              </select>
                            </div>
                          </>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-6 marginTop">
                          Infant (Under 2 Yrs)
                          <>
                            <div>
                              <select className="adult-border" onChange={handleChange} name="infantcount" value={search_data.infantcount}>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                              </select>
                            </div>
                          </>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-6 marginTop">
                          Class
                          <>
                            <div>
                              <select className="adult-border">
                                <option value="1" selected>All</option>
                                <option value="2" >Economy</option>
                                <option value="3" >Premium Economy</option>
                                <option value="4">Business</option>
                                <option value="5">Premium Business</option>
                                <option value="6">First class</option>
                              </select>

                            </div>
                          </>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-12 marginTop">
                          <button type="button"
                            onClick={search_flights}
                            className="btn btn-primary ">
                            Flight Search
                          </button>
                        </div>
                      </div>
                    </div>
                }


              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
export default FlightSearch;
